import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/header.scss";
import "../../Assets/Styles/pages/uploadImage.scss";
import CancelButton from "../Cancel_button/Cancel_button";
import { CircularProgress } from "@mui/material";
import landscape from "../../Assets/Images/landscape.svg";
import portrait from "../../Assets/Images/portrait.svg";
import {
  setID,
  setBatchImages,
  setCreate_Template,
} from "../../Redux/UserSlice/userSlice";
import { GetTemplateData } from "../../actions/Template/Template";
import NoTemplates from "../NoTemplates/noTemplates";
import helper_functions from "../../Config/helper_functions";
const SelectTemplate = ({
  open,
  setOpen,
  portraitTemp,
  setPortrait,
  landcsapeTemp,
  setLandcsape,
  setOpenUploadImage,
}) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userSliceState = useSelector((state) => state["userSlice"]);
  useEffect(() => {
    if (
      Object.keys(userSliceState.user_Auth).length &&
      Object.keys(userSliceState.template).length
    )
      setTemplates(userSliceState.template);
  }, [userSliceState]);

  const handleLoad = () => {
    setLoading(false);
  };
  const handleTemplateNext = () => {
    if (landcsapeTemp || portraitTemp) {
      var temp1 = landcsapeTemp ? landcsapeTemp : 0;
      var temp2 = portraitTemp ? portraitTemp : 0;
      if (temp1) dispatch(GetTemplateData(landcsapeTemp.id, [], false, false));
      if (temp2) dispatch(GetTemplateData(portraitTemp.id, [], false, false));

      dispatch(
        setID({
          landcsapeTemp: temp1.id,
          portraitTemp: temp2.id,
        })
      );
      dispatch(setBatchImages(true));
      setOpen(false);
      setOpenUploadImage(true);
    }
  };
  const handleTemplateCreate = () => {
    setLandcsape(null);
    setPortrait(null);
    setOpen(false);
    setOpenUploadImage(true);
    dispatch(setCreate_Template(true));
  };
  return (
    <Modal
      style={{ overflow: "hidden" }}
      open={open}
      onClose={() => {
        setLandcsape(null);
        setPortrait(null);
        dispatch(setBatchImages(false));
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model  noScroller template_modal  p-4 pb-0 p-0 m-0">
          <CancelButton
            close={() => {
              setLandcsape(null);
              setPortrait(null);
              setOpen(false);
            }}
          />
          <div className="p-2 pb-0">
            <Row className="  pb-0 d-flex justify-content-center align-items-center">
              <Row className="d-flex justify-content-center line_height_100pc mb-2 align-items-center productSansBold text_22 black_0C0C0C">
                {t("SelectTemplate")}
              </Row>
              <Row className="productSansLight text_15 line_height_100pc mb-3 d-flex justify-content-center">
                {t("SelectTemplateDescription")}
              </Row>
            </Row>
          </div>
          {templates.length ? (
            <Row
              className="w-100 px-2 border-top h_23_rem m-0 p-0 pt-2 justify-content-center"
              style={{ overflow: "hidden" }}
            >
              <div
                className="m-0 border-end w-50 px-3 p-0"
                style={{ height: "25rem", overflow: "hidden" }}
              >
                <Row className="m-1 d-flex align-items-center">
                  <img
                    className="templatesThumbList"
                    src={portrait}
                    alt="portrait"
                  />
                  <Col className={"m-0 ms-2 ps-1 p-0"}>
                    <Row className="productSansBold line_height_100pc  text_22">
                      {t("Portrait")}
                    </Row>
                    <Row className="productSansLight text_15 line_height_100pc mt-2 templateChoose">
                      {t("SelectPortrait")}
                    </Row>
                  </Col>
                </Row>
                <Col
                  className="noScroller "
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "75%",
                  }}
                >
                  {templates?.map((template, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() => {
                          portraitTemp && portraitTemp.id === template.id
                            ? setPortrait(null)
                            : setPortrait(template);
                        }}
                        className={` p-0 ${
                          portraitTemp && portraitTemp.id === template.id
                            ? "tempSelected tempHover"
                            : "tempHover tempNotSelected"
                        }`}
                      >
                        <Row className="m-1 my-3 top_60 d-flex align-items-center">
                          {loading && <CircularProgress />}
                          <img
                            className="templatesThumbList me-2"
                            onLoad={handleLoad}
                            alt="Thumb horizontal"
                            style={{
                              objectFit: "contain",
                            }}
                            src={template.media.thumbUrl}
                          />

                          <Col className={"m-0 p-0 ms-2 ps-2"}>
                            <Row className="productSansBold text_16">
                              {template.name}
                            </Row>
                            <Row className="productSansLight text_13 templateDate">
                              {template.date
                                ? helper_functions.unixTimestampToDateTime(
                                    template.date
                                  )
                                : ""}
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>
              </div>
              <div
                className="m-0 px-5 p-0 w-50"
                style={{ overflow: "hidden", height: "25rem" }}
              >
                <Row className=" top_60 d-flex align-items-center m-1">
                  <img
                    className="templatesThumbList"
                    src={landscape}
                    alt="landcape"
                  />
                  <Col className={"m-0 ms-3 p-0"}>
                    <Row className="productSansBold line_height_100pc text_22">
                      {t("Landscape")}
                    </Row>
                    <Row className="productSansLight line_height_100pc mt-2 text_15 templateChoose">
                      {t("SelectLandscape")}
                    </Row>
                  </Col>
                </Row>
                <Col
                  className="noScroller"
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "75%",
                  }}
                >
                  {templates?.map((template, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() => {
                          landcsapeTemp && landcsapeTemp.id === template.id
                            ? setLandcsape(null)
                            : setLandcsape(template);
                        }}
                        className={`p-0 ${
                          landcsapeTemp && landcsapeTemp.id === template.id
                            ? "tempSelected tempHover"
                            : "tempHover tempNotSelected"
                        }`}
                      >
                        <Row className="m-1 my-3 top_60 d-flex align-items-center">
                          {loading ? (
                            <CircularProgress />
                          ) : (
                            <img
                              className="templatesThumbList me-2"
                              onLoad={handleLoad}
                              alt="Thumb vertical"
                              style={{
                                objectFit: "contain",
                              }}
                              src={template.media.thumbUrl}
                            />
                          )}
                          <Col className={"m-0 p-0 ms-2 ps-2"}>
                            <Row className="productSansBold text_16">
                              {template.name}
                            </Row>
                            <Row className="productSansLight text_13 templateDate">
                              {template.date
                                ? helper_functions.unixTimestampToDateTime(
                                    template.date
                                  )
                                : ""}
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </Col>
              </div>
            </Row>
          ) : (
            <NoTemplates list={true} />
          )}
          <Row className="modal-buttons productSansLight text_13 px-0 justify-content-center align-items-end mx-0">
            <button
              onClick={handleTemplateCreate}
              className="button_text m-0 w_8_rem py-1 mx-2 bgCreate border-0 d-flex justify-content-center align-items-center button_text_signin"
            >
              <span className="p-1 line_height_100pc">{t("CreateNew")}</span>
            </button>
            <button
              disabled={!landcsapeTemp && !portraitTemp}
              onClick={handleTemplateNext}
              className={`button_text m-0 w_8_rem py-1 mx-2 ${
                landcsapeTemp || portraitTemp ? "bgNew" : "bgDisabled"
              } border-0 d-flex justify-content-center align-items-center button_text_signin`}
            >
              <span className="p-1 line_height_100pc">{t("Next")}</span>
            </button>
          </Row>
        </Row>
      </Fade>
    </Modal>
  );
};

export default SelectTemplate;
